import React from 'react';
import { Carousel } from '@xo-union/ui-carousel';
import { NextButton, PrevButton } from '../../../components/TansientRoomRailCard/Buttons';
import styles from './FeaturedThemes.scss';
import { PaginatedThemeCard } from '../../PaginatedThemes/PaginatedThemeCard';
import { Subhead } from '@xo-union/tk-ui-typography';

export const FeaturedThemes = ({
  themes = [],
}: {
  themes?: {
    family?: string | null;
    themes?: Array<any> | null;
  }[];
}) => {
  return (
    <div className={styles.featuredThemesContainer}>
      <Subhead bold className={styles.subhead}>
        Recommended for you
      </Subhead>
      <Carousel
        gutter={24}
        minSlideWidth={200}
        maxSlideWidth={400}
        responsive={({ width }: { width: number }) => ({ slides: width < 768 ? 1 : 3 })}
        renderNextButton={NextButton}
        renderPrevButton={PrevButton}
      >
        {themes.map((theme, index) => (
          <div key={theme.family ?? index} className={styles.themeSlide}>
            <PaginatedThemeCard
              family={theme as any}
              index={index}
              themesCount={themes.length}
              trackingProps={{ createGridOrder: 'recommended row' }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
